/**
 * Signal de mutation.
 *
 * Les alertes sont recalculées à partir de la base, pas déduites de l'écran : elles ne
 * peuvent donc pas savoir d'elles-mêmes qu'une action vient de changer quelque chose.
 * Chaque mutation réussie passe par `callFunction` — c'est le seul point d'écriture de
 * l'application — qui émet ici un signal. Le centre d'alertes s'y abonne et se remet à
 * jour, sans que chaque écran ait à y penser.
 *
 * Volontairement minuscule : un émetteur, des abonnés, rien d'autre. Aucune dépendance,
 * pour rester importable depuis la couche des commandes sans risque de cycle.
 */
const subscribers = new Set()

const alertsBus = {
  /**
   * S'abonne aux mutations.
   * @param {function} handler appelé avec le nom de la fonction métier exécutée
   * @returns {function} désabonnement
   */
  subscribe(handler) {
    if (typeof handler !== 'function') return () => {}
    subscribers.add(handler)
    return () => subscribers.delete(handler)
  },

  /** Signale une mutation réussie. Un abonné défaillant n'interrompt pas les autres. */
  notify(name) {
    for (const handler of Array.from(subscribers)) {
      try {
        handler(name)
      } catch (error) {
        console.warn('[alertes] abonné en échec :', error)
      }
    }
  },
}

export default alertsBus
